/* ⚛ REACT */
import { useState, useEffect } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button } from "../../Components";

/* 📁 ASSETS*/
import { Back } from "../../Assets/icons";

/* 🎨 STYLES */
import { CalendarContainer, BackIcon } from "./styles";

/* 🔧 UTILS */
import { getWeekDayInitiais, getMonthString } from "../../util/Months";

const Calendar = ({ container, title, selectedDate, onDateChange }) => {
    const { t } = useTranslation();

    const daysOfWeek = [];
    const months = [];

    for(let i = 0; i < 7; i++){
        daysOfWeek.push(i);
    }

    
    for(let i=0; i< 12; i++){
        months.push(i);
    }

    
    const [month, setMonth] = useState(new Date(selectedDate).getMonth());
    const [year, setYear] = useState(new Date(selectedDate).getFullYear());
    
    useEffect(() => {
        setMonth(new Date(selectedDate).getMonth());
        setYear(new Date(selectedDate).getFullYear());
    }, [selectedDate]);

    const handleSelectDate = (day) => {
        onDateChange(new Date(year, month, day));
    }

    const handleBackToday = () => {
        const today = new Date();
        onDateChange(today);
        setMonth(today.getMonth());
        setYear(today.getFullYear());
    }

    const getDaysInMonth = (month, year) => {
        return new Date(year, month + 1, 0).getDate();
    }

    const getFirstDayOfMonth = (month, year) => {
        return new Date(year, month, 1).getDay();
    }

    const daysInMonth = getDaysInMonth(month, year);
    const firstDay = getFirstDayOfMonth(month, year);

    return(
        <CalendarContainer $container={container}>
            {title && <h2>{title}:</h2>}
            <div className="header">
                <select
                value={month}
                onChange={(e) => setMonth(Number(e.target.value))}
                >
                {months.map((month, index) => (
                    <option key={index} value={index}>{getMonthString(month)}</option>
                ))}
                </select>
                <select
                value={year}
                onChange={(e) => setYear(Number(e.target.value))}
                >
                {Array.from({ length: 10 }, (_, i) => year - 5 + i).map((y) => (
                    <option key={y} value={y}>{y}</option>
                ))}
                </select>
            </div>

            <div className="calendar-grid">
                <ul className="header-row">
                {daysOfWeek.map((day, index) => (
                    <li key={index} className="day-header">
                        {getWeekDayInitiais(day)}
                    </li>
                ))}
                </ul>
                {Array(firstDay).fill(null).map((_, index) => (
                    <div key={`empty-${index}`} className="empty-slot"/>
                ))}

                {Array.from({ length: daysInMonth }, (_, i) => i + 1).map((day) => (
                    <div
                    key={day}
                    className={`day-cell ${
                        new Date(selectedDate).getDate() === day &&
                        new Date(selectedDate).getMonth() === month &&
                        new Date(selectedDate).getFullYear() === year
                        ? "selected-day"
                        : ""
                    }`}
                    onClick={() => handleSelectDate(day)}
                    >
                    {day}
                    </div>
                ))}
            </div>
            <div className="button-wrapper">
                <Button text={t("buttons.today")} color={'white-green'} icon={<BackIcon src={Back} />} onClick={() => handleBackToday()}/>
            </div>
        </CalendarContainer>
    );
};

export default Calendar;
